import React from 'react'
import { SearchBar } from '../SearchBar'
import { Table } from 'reactstrap';
import { useDispatch } from 'react-redux';
import ConfirmationModal from '../ConfirmationMessage';
import { PageLength } from '../PageLength';
import FullPageLoader from '../FullPageLoader';
import moment from 'moment-timezone';
import LiveClock from '../LiveClock';
import useDebounce from 'hooks/useDebounce';
import DebouncedInput from '../DebounceInput';
import Pagination from 'components/Pagination';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


export const PAGELENGTH = 10;


export const ListLayout = ({
    heading,
    children,
    footer,
    time,
    title,
    noOfItems,
    buttonTitle,
    renderTableHeader,
    renderTableContent,
    totalPages,
    fetchList,
    selectedItems,
    handleRemoveItems,
    refAddutton,
    renderAddForm,
    renderAddLink,
    addForm,
    handleAddPopUp,
    showConfirmDialog,
    searchTerm, setSearchTerm,
    sortConfig,
    addButtonDisabled = false,
    hideRemoveButton = false,
    renderFooter,
    hidePagination,
    hidePageLength,
    hideSearchBar,
    searchPlaceholder,
    loader,
    containerStyle,
    showRemoveOnTop,
    hideHeader,
    tableHide = false,
    colLength,
    fullMainHead,
    refAddPopUp = "#exampleModal",
    haveBackBtn = false,
    onBackButtonClick,
    disableBootstrap,
    addformModal = true,
    invoiceButton = false,
    pageLengthChange = () => { },
    paymentButton = false,
    height,
    paginationParams,
    renderFilters,
    renderCards,
    removeLine = '',
    showMainButton = false,
    downloadCsv = false,
    importCsv = false,
    onMainButtonClick = () => { },
    onDownloadCsvClick = () => { },
    onImportClick = () => { },
    defaultPageLength,
    importBtnTitle,
}) => {
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = React.useState(1);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [timeoutId, setTimeoutId] = React.useState(null);
    const [pageLength, setPageLength] = React.useState(defaultPageLength || PAGELENGTH)
    const navigate = useNavigate();
    const { t } = useTranslation();

    React.useEffect(() => {
        if (defaultPageLength) {
            setPageLength(defaultPageLength)
        }
    }, [defaultPageLength])
    const handlePageLength = React.useCallback((length) => {
        setPageLength(length)
        pageLengthChange(length)
        dispatch(fetchList(currentPage, { ...paginationParams, ...sortConfig, search: searchTerm, pageLength: length }));
    }, [sortConfig, searchTerm, currentPage, paginationParams])


    const handlePageChange = React.useCallback((page) => {
        setCurrentPage(page);
        const disableLoader = true;
        dispatch(fetchList(page, { ...paginationParams, ...sortConfig, search: searchTerm, pageLength }, disableLoader));
    }, [sortConfig, searchTerm, pageLength, paginationParams])


    const hideConfirmDialog = () => {
        setDeleteModal(false);
    }


    // const handleSearch = (value) => {
    //     setSearchTerm(value);

    //     // Clear the previous timeout if the user is still typing
    //     if (timeoutId) {
    //         clearTimeout(timeoutId);
    //     }

    //     // Set a new timeout to call the API after a delay
    //     const newTimeoutId = setTimeout(() => {
    //         const disableLoader = true;
    //         setCurrentPage(1)
    //         dispatch(fetchList(1, { ...sortConfig, search: value, }, disableLoader));
    //     }, 500); // 500ms delay

    //     setTimeoutId(newTimeoutId);
    // };

    const handleSearch = (value) => {
    setSearchTerm(value);

    // Clear the previous timeout if the user is still typing
    if (timeoutId) {
        clearTimeout(timeoutId);
    }

    const newTimeoutId = setTimeout(() => {
        setCurrentPage(1);
        const disableLoader = true;
        dispatch(fetchList(1, {
            ...paginationParams,
            ...sortConfig,
            search: value,
            pageLength,
        }, disableLoader));
    }, 500);

    setTimeoutId(newTimeoutId);
};


    const renderPagination = React.useCallback(() => {
        return (
            <div className="table-pagination pagebtn-u">
                <button
                    disabled={totalPages <= 1 || currentPage == 1}
                    className={`${(totalPages <= 1 || currentPage == 1) && "disabled-button"}`}
                    onClick={() => handlePageChange(currentPage - 1)}
                >
                    {t('common.previous')}
                </button>
                {
                    Array(totalPages).fill(0).map((count, index) => (
                        <button key={index} className={currentPage === index + 1 ? "active" : ""}
                            onClick={() => handlePageChange(index + 1)}>{index + 1}</button>
                    ))
                }
                <button
                    disabled={totalPages <= 1 || currentPage == totalPages}
                    className={`${(totalPages <= 1 || currentPage == totalPages) && "disabled-button"}`}
                    onClick={() => handlePageChange(currentPage + 1)}
                >
                    {t('common.next')}
                </button>
            </div>
        )
    }, [
        currentPage,
        totalPages,
        t,

    ])

    const handleSearchSubmit = React.useCallback(() => {

        dispatch(fetchList(currentPage, { ...sortConfig, search: searchTerm }));
    }, [sortConfig, searchTerm, currentPage])


    return (
        <>
            <div className={`content ${height}`} style={containerStyle}>
                <div className="row_main_head">
                    <div className='d-flex align-items-center gap-2'>
                        {haveBackBtn &&
                            <button className="main_heading back_button" onClick={() => onBackButtonClick ? onBackButtonClick() : navigate(-1)}>
                                <i className="fa-solid fa-arrow-left"></i> {t('common.back')}
                            </button>
                        }
                        <h2 className={`main_heading ${fullMainHead}`}>{heading}</h2>
                    </div>
                    <div className='d-flex align-items-center gap-2'>
                    {showMainButton && <button className='main_button' onClick={onMainButtonClick}>{t('common.generateCredentials')}</button>}
                    <div className='d-flex align-items-center gap-2'>
                    {importCsv && <button className='main_button' onClick={onImportClick}>{importBtnTitle}</button>}
                    {downloadCsv && <button className='main_button' onClick={onDownloadCsvClick}>{t('common.downloadCsv')}</button>}
                    </div>
                    </div>
                    {/* {time && <LiveClock />} */}
                </div>
                {renderCards &&
                    <div className=''>
                        {/* filters  */}
                        {renderCards && renderCards()}
                    </div>
                }


                <div className={`card_table ${removeLine}`}>

                    {renderFilters &&
                        <div className='row_table_head'>
                            {/* filters  */}
                            {renderFilters && renderFilters()}
                        </div>
                    }

                    {/* <hr /> */}
                    {!hideHeader && <div className="row_table_head">
                        <div className="flex justify-content-center">
                            {title && <h3 className="sub_heading mb-3" >{title}</h3>}
                            {!hidePageLength && <PageLength handlePageLength={handlePageLength} pageLength={tableHide ? 0 : pageLength} total={noOfItems} />}
                        </div>


                        <div className="row_table_head" style={{ alignItems: "center", padding: 0 }} >
                            {hideRemoveButton || selectedItems?.length > 0 && <div className="mx-4">
                                <button onClick={showConfirmDialog} className="table_delete">{t('common.delete')}</button>
                            </div>}

                            {invoiceButton && selectedItems?.length > 0 && <div className="mx-4">
                                <button className="table_delete">{t('common.generateInvoices')}</button>
                            </div>}

                            {paymentButton && selectedItems?.length > 0 && <div className="mx-4">
                                <button onClick={showConfirmDialog} className="main_button">{t('common.downloadPaymentStatements')}</button>
                            </div>}

                            {renderFooter && renderFooter()}
                            {!hideSearchBar && <SearchBar
                                placeholder={searchPlaceholder}
                                handleChange={handleSearch}
                                keywords={searchTerm}
                            // handleSubmit={handleSearchSubmit}
                            />
                            }
                            {addformModal ? (
                                !addButtonDisabled && (
                                    disableBootstrap ? (
                                        <button
                                            className="main_button ml-4"
                                            onClick={handleAddPopUp}
                                        >
                                            {buttonTitle}
                                        </button>
                                    ) : (
                                        <button
                                            ref={refAddutton}
                                            className="main_button ml-4"
                                            data-bs-toggle="modal"
                                            data-bs-target={refAddPopUp}
                                            onClick={handleAddPopUp}
                                        >
                                            {buttonTitle}
                                        </button>
                                    )
                                )
                            ) : (
                                renderAddLink(() => {
                                    setSearchTerm("")
                                })
                            )}

                        </div>
                    </div>
                    }

                    <div className='table_responsive'>
                        <Table>
                            <thead className="text-primary">
                                {renderTableHeader()}
                            </thead>
                            <tbody>

                                {!tableHide ? renderTableContent()
                                    :
                                    // no data available
                                    <tr>
                                        <td colSpan={colLength} align='right' style={{ textAlign: "center" }} >{t('common.noDataAvailable')}</td>
                                    </tr>
                                }
                            </tbody>
                        </Table>
                    </div>

                    <div className="row_end justify-content-between">
                        <div className="">
                            {/* {!hidePagination && renderPagination()} */}
                            {(!tableHide && !hidePagination) && <Pagination
                                totalItems={noOfItems}
                                currentPage={currentPage}
                                pageLength={pageLength}
                                totalPages={totalPages}
                                handleChange={handlePageChange}
                                prevDisabled={totalPages <= 1 || currentPage == 1}
                                nextDisabled={totalPages <= 1 || currentPage == totalPages}
                            />}
                        </div>

                        {/* {hideRemoveButton || selectedItems.length > 0 && <div className="row_end float-right" style={{
                            display: showRemoveOnTop ? "none" : "flex"
                        }}>
                            <button onClick={showConfirmDialog} className="table_delete">Delete</button>
                        </div>} */}

                    </div>
                </div>
            </div>
            {children}
            {renderAddForm && renderAddForm(() => {
                setSearchTerm("")
            })}

            {loader && <FullPageLoader />}
        </>
    )
}

